import e from "./ghl-ui.es1473.js";
import t from "./ghl-ui.es787.js";
function m(r, o) {
  return r && e(r, o, t);
}
export {
  m as default
};
